import React, { Fragment } from 'react';
import { useState, useEffect } from 'react';
import cx from 'classnames/bind';

const Admins = () => {

    return (
        <div>
            <div className={cx("toggle-navigation")}>
                <div onClick={() => window.location = '/brand/admins/all'} className={cx("nav-heading")}>
                    <h3>
                        <span className={cx("sidebar-icon-spacing", "brand-admin-icon")}></span>
                        <span className={cx("navigation-title")}>Admins</span>
                    </h3>
                </div>
            </div>
       </div>
    );
}

export default Admins;